import types from "./types";


export const getDeliveryAddress = (cartId) => ({
    type: types.GET_DELIVERY_ADDRESS,
    cartId
})





